import React, { FC } from 'react';

import A from '@adsk/alloy-react-a';
import { Box } from '@adsk/alloy-react-box';
import { displayDate, displayTime } from '@adsk/alloy-react-datetime';
import EmptyState from '@adsk/alloy-react-empty-state';
import { WithAlloySuspense } from '@adsk/alloy-react-suspense';
import theme from '@adsk/alloy-react-theme';

import { useTranslation } from './i18n';

export interface MaintenanceStateProps {
  name?: string;
  endDate?: Date;
  children?: React.ReactNode;
}

const MaintenanceState: FC<MaintenanceStateProps> = ({
  name,
  endDate,
  children,
}) => {
  const { t, i18n } = useTranslation();

  const hasName = (name ?? '').length > 0;
  const hasDate = !!endDate;
  const description = t('MAINTENANCE_DESCRIPTION', {
    context: `${hasName ? 'SPECIFIC' : 'GENERAL'}${hasDate ? '_WITH_DATE' : ''}`,
    name,
    ...(endDate && {
      endTime: displayTime(endDate, { locale: i18n.language }),
      endDate: displayDate(endDate, {
        format: 'numeric',
        locale: i18n.language,
      }),
    }),
  });

  return (
    <Box
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <EmptyState
        size={EmptyState.SIZES.MEDIUM}
        illustrationType={EmptyState.ILLUSTRATION_TYPES.CRANE_CONSTRUCTION}
        title={t('MAINTENANCE_TITLE')}
        description={description}
      >
        {children ?? (
          <A
            style={theme.typography.bodyMedium}
            href="https://health.autodesk.com/"
          >
            {t('MAINTENANCE_DEFAULT_HREF_TEXT')}
          </A>
        )}
      </EmptyState>
    </Box>
  );
};

MaintenanceState.displayName = 'MaintenanceState';

export default WithAlloySuspense(MaintenanceState);
